<template>
  <!-- 通用的页脚 author: zhangxiaofeng -->
  <div class="general-footer">
    <p class="f-cb">
      <a href="https://account.glodon.com/about" target="_blank" >关于我们</a>
      <span class="split-line"></span>
      <a href="https://account.glodon.com/contact" target="_blank" >联系我们</a>
      <span class="split-line"></span>
      <router-link to="/agreement" target="_blank" >用户协议</router-link>
      <span class="split-line"></span>
      <router-link to="/privacy" target="_blank" >隐私协议</router-link>
      <!-- <span class="split-line"></span>
      <a target="_blank" href="http://jubao.glodon.com/?code=321">举报投诉</a> -->
    </p>
    <p class="record">
      <span>
      Copyright © 1998-{{nowYear}} 广联达科技股份有限公司&nbsp;<a target="_blank" href="https://beian.miit.gov.cn">京ICP备10021606号-1</a>&nbsp;<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802021391">京公网安备11010802021391号</a>
      </span>
    </p>
  </div>
</template>
<style lang="less" type="text/less">
  .general-footer{
    height: 60px;
    line-height: 22px;
    margin-top: 56px;
    text-align: center;
    position: fixed;
    bottom: 0;
    width: 100%;
    &>p{
      &>*{
        margin-right: 8px;
        font-size:12px;
        color: #FFF;
        &:last-child{
          margin-left: 8px;
        }
      }
      a{
        &:link{
          color: #FFF;
        }
        &:hover{
          color: #2079FA;
        }
      }
      .split-line{
        width: 1px;
        height: 10px;
        margin-top: 6px;
        background-color: #FFF;
      }
    }
    .record{
      bottom: 24px;
      span{
        color: #FFF;
        font-size:12px;
      }
      a{
        color: #fff;
        &:hover{
          color: #2079FA;
        }
      }
    }
  }
</style>
<script>
export default {
  name: 'FooterFixed'
}
</script>
